export default __webpack_public_path__ + "static/media/rubik-v12-latin-800.8b0ee6e0.svg";